import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

// Fix default marker icons (leaflet asset bug with bundlers)
delete (L.Icon.Default.prototype as unknown as { _getIconUrl?: unknown })._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
})

interface Props {
  lat: number
  lng: number
  zoom: number
  onChange: (next: { lat: number; lng: number; zoom: number }) => void
}

function ClickHandler({ onPick }: { onPick: (lat: number, lng: number) => void }) {
  useMapEvents({
    click: (e) => onPick(e.latlng.lat, e.latlng.lng),
  })
  return null
}

export default function MapPicker({ lat, lng, zoom, onChange }: Props) {
  const center: [number, number] =
    lat && lng ? [lat, lng] : [47.9184, 106.9177] // Ulaanbaatar default
  return (
    <div style={{ height: 320, borderRadius: 8, overflow: 'hidden' }}>
      <MapContainer center={center} zoom={zoom || 15} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{y}/{x}.png"
        />
        {lat && lng ? <Marker position={[lat, lng]} /> : null}
        <ClickHandler onPick={(la, ln) => onChange({ lat: la, lng: ln, zoom: zoom || 15 })} />
      </MapContainer>
    </div>
  )
}
